import React from 'react';
import { motion } from 'framer-motion';

const Privacy: React.FC = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white">
      {/* Hero Section */}
      <div className="bg-gradient-to-r from-purple-800 to-teal-700 py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-center text-white"
          >
            <h1 className="text-4xl font-bold mb-4">Privacy Policy</h1>
            <p className="text-xl text-purple-100 max-w-3xl mx-auto">
              Your privacy is important to us. Learn how we protect and manage your data.
            </p>
          </motion.div>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="prose prose-lg max-w-none">
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.2 }}
          >
            <section className="mb-12">
              <h2>1. Introduction</h2>
              <p>
                At Pincode Pro, we take your privacy seriously. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website or use our API services.
              </p>
            </section>

            <section className="mb-12">
              <h2>2. Information We Collect</h2>
              <h3>2.1 Information You Provide</h3>
              <ul>
                <li>Contact information (name, email, phone number)</li>
                <li>Search queries and postal codes</li>
                <li>API usage data</li>
                <li>Feedback and correspondence</li>
              </ul>

              <h3>2.2 Automatically Collected Information</h3>
              <ul>
                <li>IP address and device information</li>
                <li>Browser type and settings</li>
                <li>Usage patterns and preferences</li>
                <li>Cookies and similar tracking technologies</li>
              </ul>
            </section>

            <section className="mb-12">
              <h2>3. How We Use Your Information</h2>
              <p>We use the collected information for:</p>
              <ul>
                <li>Providing and improving our services</li>
                <li>Processing your searches and requests</li>
                <li>Analyzing usage patterns and trends</li>
                <li>Communicating with you about our services</li>
                <li>Preventing fraud and abuse</li>
                <li>Complying with legal obligations</li>
              </ul>
            </section>

            <section className="mb-12">
              <h2>4. Data Security</h2>
              <p>
                We implement appropriate technical and organizational security measures to protect your information, including:
              </p>
              <ul>
                <li>Encryption of data in transit and at rest</li>
                <li>Regular security assessments</li>
                <li>Access controls and authentication</li>
                <li>Secure data storage practices</li>
              </ul>
            </section>

            <section className="mb-12">
              <h2>5. Data Sharing and Disclosure</h2>
              <p>We may share your information with:</p>
              <ul>
                <li>Service providers and partners who assist in operating our service</li>
                <li>Law enforcement when required by law</li>
                <li>Third parties with your explicit consent</li>
              </ul>
            </section>

            <section className="mb-12">
              <h2>6. Your Rights and Choices</h2>
              <p>You have the right to:</p>
              <ul>
                <li>Access your personal information</li>
                <li>Correct inaccurate data</li>
                <li>Request deletion of your data</li>
                <li>Opt-out of marketing communications</li>
                <li>Withdraw consent where applicable</li>
              </ul>
            </section>

            <section className="mb-12">
              <h2>7. Cookies and Tracking</h2>
              <p>
                We use cookies and similar tracking technologies to improve your experience and analyze usage patterns. You can control cookie settings through your browser preferences.
              </p>
            </section>

            <section className="mb-12">
              <h2>8. Children's Privacy</h2>
              <p>
                Our service is not intended for children under 13 years of age. We do not knowingly collect or maintain information from children under 13.
              </p>
            </section>

            <section className="mb-12">
              <h2>9. International Data Transfers</h2>
              <p>
                Your information may be transferred to and processed in countries other than your own. We ensure appropriate safeguards are in place for such transfers.
              </p>
            </section>

            <section className="mb-12">
              <h2>10. Changes to This Policy</h2>
              <p>
                We may update this privacy policy from time to time. We will notify you of any changes by posting the new policy on this page and updating the "last updated" date.
              </p>
            </section>

            <section className="mb-12">
              <h2>11. Contact Us</h2>
              <p>
                If you have any questions about this Privacy Policy, please contact us at:
              </p>
              <ul>
                <li>Email: contact@pincodeindia.tag360.in</li>
                <li>Phone: NA</li>
                <li>Address: New Delhi, India</li>
              </ul>
            </section>
          </motion.div>
        </div>

        <div className="mt-12 text-center">
          <p className="text-gray-600">
            Last updated: January 6, 2025
          </p>
        </div>
      </div>
    </div>
  );
};

export default Privacy;
